import { useTranslation } from 'react-i18next';
import type { ServiceChoice } from '@/types';

/**
 * DF-0586 — the table's choice, as two direct buttons (each button IS the
 * choice, no separate « Valider »): everything at once, or the first service
 * now and the next ones when the waiter sends them. `services` are the
 * cart's services in kitchen order, from `serviceChoiceQuestion`.
 */
export default function ServiceChoiceButtons({
  services,
  onChoose,
  disabled = false,
}: {
  services: string[];
  onChoose: (choice: ServiceChoice) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-3" data-testid="service-choice">
      <button
        type="button"
        onClick={() => onChoose('all')}
        disabled={disabled}
        data-testid="service-choice-all"
        className="w-full bg-mint text-[var(--on-primary)] border-2 border-ink rounded-btn px-5 py-3 font-display shadow-stamp-sm disabled:opacity-50"
      >
        {t('serviceChoice.all')}
      </button>
      <button
        type="button"
        onClick={() => onChoose('by_course')}
        disabled={disabled}
        data-testid="service-choice-by-course"
        className="w-full bg-mint text-[var(--on-primary)] border-2 border-ink rounded-btn px-5 py-3 font-display shadow-stamp-sm disabled:opacity-50"
      >
        <span className="block">{t('serviceChoice.byCourse', { first: services[0] })}</span>
        <span className="block font-mono text-xs opacity-80">
          {t('serviceChoice.byCourseHint', { sequence: services.join(' → ') })}
        </span>
      </button>
    </div>
  );
}
